import type { Auth } from 'firebase/auth';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import {
  connectFirestoreEmulator,
  initializeFirestore,
} from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDG_Xdlt6gyYdR_lH66_K8zaqrI_e574ko',
  authDomain: 'breakfast-8ac2d.firebaseapp.com',
  projectId: 'breakfast-8ac2d',
  storageBucket: 'breakfast-8ac2d.appspot.com',
  messagingSenderId: '423798668073',
  appId: '1:423798668073:web:816d57444ced42a2ae1538',
  measurementId: 'G-66059JGPQV',
};

const app = initializeApp(firebaseConfig);

const firestore = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});

const auth: Auth = getAuth(app);

const functions = getFunctions(app);

const storage = getStorage(app);

const analytics = getAnalytics(app);

export const shouldUseEmulators =
  process.env.NODE_ENV === 'development' &&
  import.meta.env.VITE_APP_USE_FIREBASE_EMULATORS == 'true';

if (shouldUseEmulators) {
  const host = import.meta.env.VITE_APP_FIREBASE_EMULATOR_HOST ?? '127.0.0.1';
  const authPort =
    import.meta.env.VITE_APP_FIREBASE_AUTH_EMULATOR_PORT ?? '9099';
  const firestorePort =
    import.meta.env.VITE_APP_FIREBASE_FIRESTORE_EMULATOR_PORT ?? '8080';
  const storagePort =
    import.meta.env.VITE_APP_FIREBASE_STORAGE_EMULATOR_PORT ?? '9199';
  const functionsPort =
    import.meta.env.VITE_APP_FIREBASE_FUNCTIONS_EMULATOR_PORT ?? '5001';
  console.info(`Practist 'admin' app is using Firebase emulators`);
  console.log(`Auth emulator: http://${host}:${authPort}`);
  console.log(`Firestore emulator: http://${host}:${firestorePort}`);
  console.log(`Storage emulator: http://${host}:${storagePort}`);
  console.log(`Functions emulator: http://${host}:${functionsPort}`);

  connectAuthEmulator(auth, `http://${host}:${authPort}`);
  connectFirestoreEmulator(firestore, host, parseInt(firestorePort, 10));
  connectStorageEmulator(storage, host, parseInt(storagePort, 10));
  connectFunctionsEmulator(functions, host, parseInt(functionsPort, 10));
}

const firebase = {
  app,
  firestore,
  auth,
  functions,
  storage,
  analytics,
};

export { firebase };
